import styled from '@emotion/styled';

const Ruler = styled.hr`
  height: 1px;
  width: 100%;
  background: #b5c1dc;
  border: none;
  margin: ${(props) => props.theme.modularScale.xlarge} 0;
  order: 99;
`;

Ruler.whyDidYouRender = true;

export default Ruler;
